export const limitsChange = {
    hasAllowedLimits: true,
};
